import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useIsAdmin } from '@/lib/queries';
import { Spinner } from '@/components/Layout';
import { csvCell } from '@/lib/csv';

const tab = ({ isActive }: { isActive: boolean }) =>
  `border-b-2 px-1 pb-2 text-sm font-medium ${isActive ? 'border-brand-600 text-brand-700' : 'border-transparent text-ink-500 hover:text-ink-900'}`;

/** Admin area. The database (RLS) is what actually protects the data; this only hides the screens from non-admins. */
export function AdminLayout() {
  const admin = useIsAdmin();
  if (admin.isLoading) return <Spinner />;
  if (!admin.data) return <Navigate to="/home" replace />;
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-stone-200">
        <h1 className="pb-2 text-2xl font-bold">Admin{admin.isViewer && <span className="pill ml-3 bg-stone-100 align-middle text-sm font-semibold text-ink-700">View only</span>}</h1>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          <NavLink to="/admin/events" className={tab}>Events</NavLink>
          <NavLink to="/admin/members" className={tab}>Members</NavLink>
          <NavLink to="/admin/payments" className={tab}>Payments</NavLink>
          <NavLink to="/admin/email" className={tab}>Email</NavLink>
          <NavLink to="/admin/dojos" className={tab}>Dojos</NavLink>
          <NavLink to="/admin/instructors" className={tab}>Instructors</NavLink>
          <NavLink to="/admin/certificates" className={tab}>Certificates</NavLink>
          <NavLink to="/admin/history" className={tab}>History</NavLink>
        </nav>
      </div>
      <Outlet />
    </div>
  );
}

/** A CSV download built in the browser from rows the admin can already see. */
export function downloadCsv(filename: string, rows: (string | number | null | undefined)[][]) {
  const blob = new Blob([rows.map(r => r.map(csvCell).join(',')).join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
